
let initialState = {};

const sidebarReducer = (state: any = initialState, action: any) => {

    return state
}

export default sidebarReducer;